import styled from 'styled-components';

export const ButtonContainer = styled.span`
  display: flex;
  flex-direction: ${({ isModal }) => (isModal ? 'row-reverse' : 'row')};
`;
